import React, { createContext, useContext,  useState } from "react";

const TabContext = createContext();

export const useTab = () => {
  return useContext(TabContext);
};

export const NotificationTabProvider = ({ children }) => {
  const [tab, setTab] = useState('nomination');

  return (
    <TabContext.Provider value={{ tab, setTab }}>
      {children}
    </TabContext.Provider>
  );
};
